import Checkbox from "@material-ui/core/Checkbox"
import createSelectionComponent from "./createSelectionComponent"

export default createSelectionComponent(Checkbox, {
  defaultCheckedValue: true,
  isChecked: v => v,
})



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Field/Checkbox.js